var _defs, _path, _path2, _path3, _path4, _path5, _use, _use2, _g, _g2, _use3, _use4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNz = function SvgNz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1200 600"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "nz_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h600v300H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nz_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 300 150H0zm300 0h300L300 150zm0 150h300v150zm0 0v150H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "nz_svg__d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nz_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-.325v.5l1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.19.263-.293-.405L1-.325z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__a",
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__a",
    transform: "rotate(72 0 0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__a",
    transform: "rotate(-72 0 0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__a",
    transform: "scale(-1 1)rotate(72)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h1200v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 60,
    d: "m0 0 600 300M0 300 600 0",
    clipPath: "url(#nz_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C8102E",
    strokeWidth: 40,
    d: "m0 0 600 300M0 300 600 0",
    clipPath: "url(#nz_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 100,
    d: "M300 0v300M0 150h600",
    clipPath: "url(#nz_svg__b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C8102E",
    strokeWidth: 60,
    d: "M300 0v300M0 150h600",
    clipPath: "url(#nz_svg__b)"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__d",
    fill: "#FFF",
    transform: "translate(900 120)scale(45.4)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__d",
    fill: "#C8102E",
    transform: "matrix(30 0 0 30 900 120)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(82 900 240)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__d",
    fill: "#FFF",
    transform: "rotate(-82 519.022 -457.666)scale(40.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__d",
    fill: "#C8102E",
    transform: "rotate(-82 519.022 -457.666)scale(25)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(82 900 240)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__d",
    fill: "#FFF",
    transform: "rotate(-82 668.57 -327.666)scale(45.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__d",
    fill: "#C8102E",
    transform: "rotate(-82 668.57 -327.666)scale(30)"
  }))), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__d",
    fill: "#FFF",
    transform: "translate(900 480)scale(50.4)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__d",
    fill: "#C8102E",
    transform: "matrix(35 0 0 35 900 480)"
  })));
};
export default SvgNz;